/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Linesheet_Status_ApprovedInputs */

const en_linesheet_status_approved = /** @type {(inputs: Linesheet_Status_ApprovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Approved`)
};

/**
* | output |
* | --- |
* | "Approved" |
*
* @param {Linesheet_Status_ApprovedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const linesheet_status_approved = /** @type {((inputs?: Linesheet_Status_ApprovedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Linesheet_Status_ApprovedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_linesheet_status_approved(inputs)
});